import { inject } from '@angular/core';
import { FeaturesService } from '@core/services/features.service';
import { Feature as Feature } from '@shared/constants/feature';
import { Observable, filter, map } from 'rxjs';

export const isFeatureEnabledGuard = (
  neededFeature: Feature
): Observable<boolean> => {
  const featuresService = inject(FeaturesService);

  return featuresService.getFeatures().pipe(
    filter(feats => !!feats.length),
    map(features => {
      return features.includes(neededFeature);
    })
  );
};
